import { useMemo, useState } from 'react'
import ReactDataGrid from 'react-data-grid'
import { sortColumn, sortRows } from './sortingHelper'
import './DataGrid.scss'

export const DataGrid = ({ rows, columns, defaultSortColumn, onRowClick }) => {
  const rowHeight = 70
  const headerRowHeight = 50

  const [sortColumns, setSortColumns] = useState([{
    columnKey: defaultSortColumn,
    direction: "DESC"
  }])

  const sortedRows = useMemo(() => {
    if (sortColumns.length === 0) return rows
    return [...rows].sort(sortRows(sortColumns))
  }, [rows, sortColumns])

  return (
    <ReactDataGrid
      manualColumnResize={true}
      columns={columns}
      rows={sortedRows}
      sortColumns={sortColumns}
      onSortColumnsChange={(e)=> setSortColumns(sortColumn(e))}
      rowHeight={rowHeight}
      headerRowHeight={headerRowHeight}
      style={{
        height: ((rows.length * rowHeight) + headerRowHeight),
        border: 'none',
        width: '100%',
        cursor: onRowClick ? 'pointer' : 'default'
      }}
      rowClass={() => 'custom-row' + (onRowClick ? ' row-hover' : '')}
      className="custom-grid"
      onRowClick={onRowClick}
    />
  )
}